(() => {
  const DEFAULT_IMAGE_URL =
    'https://cdn.shopify.com/s/files/1/0920/7863/7352/files/cbg_default_image_3696c395-2961-453a-a94b-3f083b2f38b9.png?v=1755276869&width=533';
  const DEFAULT_IMAGE_TOKEN = 'cbg_default_image_3696c395-2961-453a-a94b-3f083b2f38b9';

  const SEARCHANISE_SCOPE_SELECTOR = [
    '[id*="snize-search"]',
    '[id*="snize-results"]',
    '[class*="snize-search"]',
    '[class*="snize-results"]',
    '[id*="searchanise"]',
    '[class*="searchanise"]',
  ].join(',');

  const PRODUCT_IMAGE_CONTAINER_SELECTOR = [
    '[class*="snize-product"]',
    '[class*="snize-item"]',
    '[data-snize-product-id]',
    '[data-product-id]',
  ].join(',');

  const PLACEHOLDER_URL_PATTERNS = [
    'cdn.searchanise.com/images/no_image',
    '/no_image.',
    '/no-image.',
    '/images/noimage',
    '/images/placeholder',
  ];

  function normalize(value) {
    return (value || '').trim();
  }

  function extractSrcsetUrls(srcsetValue) {
    const srcset = normalize(srcsetValue);
    if (!srcset) return [];
    return srcset
      .split(',')
      .map((entry) => entry.trim().split(/\s+/)[0])
      .filter(Boolean);
  }

  function hasDefaultImage(urlValue) {
    return normalize(urlValue).toLowerCase().includes(DEFAULT_IMAGE_TOKEN);
  }

  function isPlaceholderUrl(urlValue) {
    const url = normalize(urlValue).toLowerCase();
    if (!url) return true;
    if (hasDefaultImage(url)) return false;
    if (url === '#' || url === 'about:blank' || url.startsWith('javascript:')) return true;
    if (url.startsWith('data:image')) return true;
    return PLACEHOLDER_URL_PATTERNS.some((pattern) => url.includes(pattern));
  }

  function isValidRealUrl(urlValue) {
    const url = normalize(urlValue);
    if (!url) return false;
    if (hasDefaultImage(url)) return true;
    if (isPlaceholderUrl(url)) return false;
    return (
      url.startsWith('https://') ||
      url.startsWith('http://') ||
      url.startsWith('//') ||
      url.startsWith('/')
    );
  }

  function hasProductLinkInCard(element) {
    const container = element.closest(PRODUCT_IMAGE_CONTAINER_SELECTOR);
    if (!container) return false;
    if (container.matches('a[href*="/products/"]')) return true;
    return Boolean(container.querySelector('a[href*="/products/"]'));
  }

  function isInsideSearchaniseScope(element) {
    return Boolean(element && element.closest && element.closest(SEARCHANISE_SCOPE_SELECTOR));
  }

  function isSearchaniseProductImage(img) {
    if (!isInsideSearchaniseScope(img)) return false;
    if (img.closest('a[href*="/products/"]')) return true;
    return hasProductLinkInCard(img);
  }

  function shouldApplyFallback(img) {
    if (!isSearchaniseProductImage(img)) return false;

    const src = normalize(img.getAttribute('src'));
    const dataSrc = normalize(img.getAttribute('data-src'));
    const dataOriginal = normalize(img.getAttribute('data-original'));
    const dataLazy = normalize(img.getAttribute('data-lazy'));
    const srcsetUrls = extractSrcsetUrls(img.getAttribute('srcset'));
    const dataSrcsetUrls = extractSrcsetUrls(img.getAttribute('data-srcset'));

    const urls = [src, dataSrc, dataOriginal, dataLazy, ...srcsetUrls, ...dataSrcsetUrls].filter(Boolean);
    if (!urls.length) return true;
    if (urls.some(isValidRealUrl)) return false;

    return urls.every(isPlaceholderUrl);
  }

  function applyFallback(img) {
    if (!shouldApplyFallback(img)) return;

    img.setAttribute('src', DEFAULT_IMAGE_URL);
    img.setAttribute('srcset', `${DEFAULT_IMAGE_URL} 533w`);

    if (img.hasAttribute('data-src')) img.setAttribute('data-src', DEFAULT_IMAGE_URL);
    if (img.hasAttribute('data-original')) img.setAttribute('data-original', DEFAULT_IMAGE_URL);
    if (img.hasAttribute('data-lazy')) img.setAttribute('data-lazy', DEFAULT_IMAGE_URL);
    if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', `${DEFAULT_IMAGE_URL} 533w`);
  }

  function scanImages(root = document) {
    const scope = root && root.querySelectorAll ? root : document;
    const images = [];

    if (root && root.nodeType === Node.ELEMENT_NODE && root.tagName === 'IMG') {
      images.push(root);
    }

    scope.querySelectorAll('img').forEach((img) => images.push(img));
    images.forEach(applyFallback);
  }

  let scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(() => {
      scanQueued = false;
      scanImages(document);
    });
  }

  document.addEventListener(
    'error',
    (event) => {
      const target = event.target;
      if (target && target.tagName === 'IMG') {
        applyFallback(target);
      }
    },
    true
  );

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        const target = mutation.target;
        if (target instanceof Element && (target.tagName === 'IMG' || target.closest('img'))) {
          queueScan();
          return;
        }
      }

      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('img') || node.querySelector('img')) {
          queueScan();
          return;
        }
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => queueScan());
  } else {
    queueScan();
  }

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'data-src', 'data-original', 'data-lazy', 'data-srcset'],
  });
})();
